module.exports = __webpack_public_path__ + "img/PAMMAccountLogo3.d5e3d865.svg";